import PropTypes from 'prop-types';

import CustomIcon from '../../CustomIcons';
import NavigationItem from './NavigationItem';

function Navigations({
  navItems,
  handleChildNav,
  tabs,
  handleParentNav,
  pathname,
  activeTabName,
  setHostName,
  loaderNavLabel
}) {
  return (
    <ul className="flex-group">
      {tabs.length > 1 && (
        <h3 className="global-nav__parent-tab b">
          <button className="header__btn" type="button" onClick={handleParentNav}>
            <CustomIcon size="30" type="backArrow" className="right-arrow" fill="#FFF" />
            <span className="parent-tab">{activeTabName}</span>
          </button>
        </h3>
      )}
      {navItems.map(item => {
        const {
          link: { title }
        } = item;
        return (
          <NavigationItem
            key={title}
            item={item}
            pathname={pathname}
            handleChildNav={handleChildNav}
            setHostName={setHostName}
            isLoader={'isProductsLoader' in item}
            loaderNavLabel={loaderNavLabel}
          />
        );
      })}
    </ul>
  );
}

Navigations.propTypes = {
  navItems: PropTypes.instanceOf(Array).isRequired,
  handleChildNav: PropTypes.func.isRequired,
  setHostName: PropTypes.func.isRequired,
  tabs: PropTypes.instanceOf(Array),
  handleParentNav: PropTypes.func.isRequired,
  loaderNavLabel: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  activeTabName: PropTypes.string
};

Navigations.defaultProps = {
  tabs: [],
  pathname: '',
  activeTabName: ''
};

export default Navigations;
